import React, { useState } from 'react';
import { Cpu, Battery, Gauge, Activity, CheckCircle2 } from 'lucide-react';

export const ProstheticsModule: React.FC = () => {
  return (
    <div className="p-6 space-y-6 bg-slate-900 text-white rounded-2xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-800 pb-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-emerald-500/20 text-emerald-300 text-xs font-bold rounded-full border border-emerald-500/30">
            <Cpu className="w-3.5 h-3.5" /> Module 24: Prosthetics, Orthotics & Exoskeleton Fitting
          </div>
          <h2 className="text-2xl font-black mt-2">Bionic Limb Myoelectric Calibration & Gait Telemetry</h2>
        </div>
      </div>

      <div className="bg-slate-950 p-5 rounded-2xl border border-slate-800 space-y-4">
        <div className="flex items-center justify-between text-xs font-bold">
          <span>Active Bionic Hand Telemetry:</span>
          <span className="text-emerald-400 font-mono">Battery 94% • Motors Calibrated</span>
        </div>
        <div className="w-full bg-slate-900 h-3 rounded-full overflow-hidden">
          <div className="bg-emerald-500 h-full rounded-full" style={{ width: '94%' }} />
        </div>
      </div>
    </div>
  );
};
